import React from 'react';
import {
    breakpointMedium,
    breakpointExtraSmall,
    breakpointSmall,
} from 'config/styles/breakpoints';

const VariantOptionsList = ({
    optionName,
    variantOptions,
    unavailableOptions,
    selectedOption,
    callback,
    preventUnavailableSelection = false,
}) => {
    const uniqueOptions = [
        ...new Set(variantOptions.map((option) => option[optionName])),
    ];

    const shortFormSizeName = (longForm) => {
        switch (longForm.toLowerCase()) {
            case 'extra':
                return 'X';
            case 'small':
                return 'S';
            case 'medium':
                return 'M';
            case 'large':
                return 'L';
            default:
                return longForm;
        }
    };

    return (
        <nav>
            {uniqueOptions.map((option) => {
                const disabled =
                    unavailableOptions &&
                    unavailableOptions.indexOf(option) !== -1;
                const blocked = disabled && preventUnavailableSelection;
                return (
                    <a
                        onClick={() => {
                            if (blocked) return;
                            callback(option);
                        }}
                        className={`${disabled ? 'disabled' : ''}
                             ${blocked ? 'blocked' : ''}
                             ${selectedOption === option ? 'selected' : ''}
                             `}
                        key={option}
                    >
                        {option
                            ?.split(' ')
                            .map((segment) => shortFormSizeName(segment))}
                    </a>
                );
            })}

            <style jsx>
                {`
                    nav {
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        flex-basis: 100%;
                        margin-top: 16px;
                        margin-bottom: 10px;
                        /* The frame's top and left edges live on the
                           container so the grid stays correct for any number
                           of options and any wrap point; each cell only draws
                           its right and bottom edges. */
                        border-top: 1px solid rgba(0, 0, 0, 0.5);
                        border-left: 1px solid rgba(0, 0, 0, 0.5);
                    }
                    a {
                        flex: 1 1 10%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                        -webkit-tap-highlight-color: transparent;
                        border-right: 1px solid rgba(0, 0, 0, 0.5);
                        border-bottom: 1px solid rgba(0, 0, 0, 0.5);
                        color: rgba(0, 0, 0);
                        font-weight: 300;
                        padding: 11px;
                        line-height: 1em;
                    }
                    a.disabled {
                        text-decoration: unset;
                    }
                    a.selected {
                        background-color: rgb(0, 0, 0);
                        color: rgb(255, 255, 255);
                    }
                    /* Defined after .selected so an unavailable option that is
                       also the selected variant still reads as blocked rather
                       than picking up the selected (black) styling. */
                    a.blocked {
                        background-color: transparent;
                        color: rgba(0, 0, 0, 0.25);
                        cursor: not-allowed;
                        text-decoration: line-through;
                    }
                    @media (max-width: ${breakpointMedium}) {
                        a {
                            flex: 1 1 12%;
                        }
                    }
                    // @media (max-width: ${breakpointSmall}) {
                    //     a {
                    //         flex: 1 1 10%;
                    //     }
                    // }
                    @media (max-width: ${breakpointExtraSmall}) {
                        a {
                            flex: 1 1 7%;
                        }
                    }
                    @media (min-width: 300px) and (max-width: 680px) {
                        a {
                            flex: 1 1 9%;
                        }
                    }
                    @media (min-width: 435px) and (max-width: 720px) {
                        a {
                            flex: 1 1 11%;
                        }
                    }
                    @media (min-width: 540px) and (max-width: 720px) {
                        a {
                            flex: 1 1 12%;
                        }
                    }
                `}
            </style>
        </nav>
    );
};

export default VariantOptionsList;
